// extracted by mini-css-extract-plugin
export default {"commentsTitle":"PostComments_commentsTitle__A+L+x","commentsContainer":"PostComments_commentsContainer__wBaTi"};